module.exports = __webpack_public_path__ + "img/m-plan-3-2.a3e1654c.png";